import axios from "axios";
import qs from "qs";
import { clearToken, getToken } from '@/utils/auth';
import { ResultEnum } from "@/enums/ResultEnum";
import { addPendingCallback, showReAuthModal } from '@/utils/reAuth';
// import.meta.env.VITE_APP_BASE_API
// 创建 axios 实例
const service = axios.create({
  baseURL: '/evaluate-api',
  timeout: 50000,
  headers: {
    "Content-Type": "application/json;charset=utf-8"
  },
  paramsSerializer: params => {
    return qs.stringify(params);
  }
});

// 请求拦截器
service.interceptors.request.use(config => {
  const accessToken = getToken();
  if (accessToken) {
    config.headers["access-token"] = accessToken;
  }
  // console.log(config);
  return config;
}, error => {
  return Promise.reject(error);
});

// 响应拦截器
service.interceptors.response.use(response => {
  // 检查配置的响应类型是否为二进制类型（'blob' 或 'arraybuffer'）, 如果是，直接返回响应对象
  if (response.config.responseType === "blob" || response.config.responseType === "arraybuffer") {
    return response;
  }
  // console.log(response);
  const {
    code,
    data,
    msg
  } = response.data;
  if (code === ResultEnum.SUCCESS) {
    return data;
  }
  if (code === ResultEnum.PASSWORD_ERROR) {
    ElMessage.error(msg);
    return Promise.reject(new Error(msg || "Error"));
  }
  if (code === ResultEnum.TOKEN_INVALID) {
    return new Promise((resolve, reject) => {
      addPendingCallback(token => {
        if (!token) {
          reject(new Error('重新登录失败'));
          return;
        }
        response.config.headers['access-token'] = token;
        service.request(response.config).then(resolve).catch(reject);
      });
      showReAuthModal();
    });
  }
  ElMessage.error(msg || "系统出错");
  return Promise.reject(new Error(msg || "Error"));
}, error => {
  // 异常处理 非 2xx 状态码 会进入这里
  if (error.response.data) {
    const {
      code,
      msg
    } = error.response.data;
    if (code === ResultEnum.TOKEN_INVALID) {
      return new Promise((resolve, reject) => {
        addPendingCallback(token => {
          if (!token) {
            reject(error);
            return;
          }
          error.config.headers['access-token'] = token;
          service.request(error.config).then(resolve).catch(reject);
        });
        showReAuthModal();
      });
    } else {
      ElMessage.error(msg || "系统出错");
    }
  }
  return Promise.reject(error.message);
});
export default service;